import React from 'react';

type ProgressBarProps = {
  progress: number;
};

function ProgressBarCircle({ active }: { active: boolean }) {
  return (
    <div className='circle-container'>
      {active ? (
        <img className='circle-active' src="https://cdn-eu.lolaenglish.com/web-images%2Fchoose.svg" alt="" />
      ) : (
        <div className='circle' />
      )}


    </div>

  )
}

function ProgressBar({ progress }: ProgressBarProps) {

  return (
    <div className='progress-bar'>
      <div className='line'>
        <div className='progress-line' style={{ transform: `scaleX(${progress})` }}></div>
      </div>
      <div className='circles'>
        <div></div>
        <ProgressBarCircle active={progress >= 0.25} />
        <ProgressBarCircle active={progress >= 0.5} />
        <ProgressBarCircle active={progress >= 0.75} />
        <ProgressBarCircle active={progress >= 1} />
      </div>

    </div>
  );
}


export default ProgressBar;

